var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleteKycIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17661",
    "data-name": "Group 17661",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.147,
    height: 132.943,
    viewBox: "0 0 120.147 132.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19546",
    "data-name": "Path 19546",
    d: "M0,290.461c0,1.774,26.9,3.212,60.074,3.212s60.074-1.438,60.074-3.212-26.9-3.212-60.074-3.212S0,288.687,0,290.461",
    transform: "translate(0 -160.729)",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17649",
    "data-name": "Group 17649",
    transform: "translate(2.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-20",
    transform: "translate(76.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19622",
    "data-name": "Path 19622",
    d: "M152.9,220.291l-2.032-.091.918,3.854a10.67,10.67,0,0,0,1.966-1.74.983.983,0,0,0-.1-1.379Z",
    transform: "translate(-123.207 -175.594)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19623",
    "data-name": "Path 19623",
    d: "M155.93,222.279l.909,3.145,2.362-1.37-.918-3.854Z",
    transform: "translate(-130.618 -175.594)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19624",
    "data-name": "Path 19624",
    d: "M197.211,169.23c-.822,1.823-1.684,3.693-2.554,5.516s-1.74,3.654-2.706,5.4c-.231.435-.479.87-.718,1.305l-.048.083h0l.039-.03a1.389,1.389,0,0,1,.435-.283,1.223,1.223,0,0,1,.252-.083,1.419,1.419,0,0,1,.3-.039,1.5,1.5,0,0,1,.552.078.991.991,0,0,1,.435.257c.061.083-.039,0-.126-.113a4.4,4.4,0,0,1-.3-.465,9.635,9.635,0,0,1-.6-1.218c-.766-1.74-1.453-3.72-2.136-5.625l-2.327.435a32.63,32.63,0,0,0,.94,6.4,14.144,14.144,0,0,0,.531,1.671,9.14,9.14,0,0,0,.435.909,4.515,4.515,0,0,0,.822,1.1,2.933,2.933,0,0,0,1.092.661,2.651,2.651,0,0,0,.935.126,2.739,2.739,0,0,0,.492-.07,2.837,2.837,0,0,0,.435-.144,3.1,3.1,0,0,0,1.048-.757,4.045,4.045,0,0,0,.278-.339l.109-.152.057-.083c.3-.435.613-.9.9-1.357,1.157-1.818,2.175-3.672,3.154-5.547s1.849-3.772,2.675-5.747Z",
    transform: "translate(-186.856 -146.798)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19625",
    "data-name": "Path 19625",
    d: "M216.943,176.7l-.474-1.531-3.045,1.305a5.507,5.507,0,0,0,1.74,2.358.979.979,0,0,0,1.349-.3h0A2.853,2.853,0,0,0,216.943,176.7Z",
    transform: "translate(-213.387 -150.154)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19626",
    "data-name": "Path 19626",
    d: "M217.011,169.73l-.487.139a2.719,2.719,0,0,0-1.962,2.706l.03.814,3.045-1.305Z",
    transform: "translate(-214.56 -147.081)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19627",
    "data-name": "Path 19627",
    d: "M212.266,171.887l2.684-.265a.27.27,0,0,0,.239-.313l-.87-5.773a.309.309,0,0,0-.331-.257l-2.68.265a.265.265,0,0,0-.244.313l.87,5.773a.313.313,0,0,0,.331.257Z",
    transform: "translate(-210.594 -144.565)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19628",
    "data-name": "Path 19628",
    d: "M211.947,171.856l2.68-.265a.274.274,0,0,0,.244-.313L214,165.5a.3.3,0,0,0-.331-.257l-2.68.265a.274.274,0,0,0-.244.313l.87,5.773A.309.309,0,0,0,211.947,171.856Z",
    transform: "translate(-210.135 -144.548)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19629",
    "data-name": "Path 19629",
    d: "M211.624,172.243l3.254-.318-.744-4.885-3.254.322Z",
    transform: "translate(-210.2 -145.561)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19630",
    "data-name": "Path 19630",
    d: "M213.283,172.161l.4-.039-1.853-4.772-.4.039Z",
    transform: "translate(-209.244 -145.736)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19631",
    "data-name": "Path 19631",
    d: "M214.758,172.333l.626-.061-1.853-4.772-.631.061Z",
    transform: "translate(-211.585 -145.821)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19632",
    "data-name": "Path 19632",
    d: "M216.068,166.22a.2.2,0,0,0,.209.161.174.174,0,0,0,.152-.2.2.2,0,0,0-.209-.165A.178.178,0,0,0,216.068,166.22Z",
    transform: "translate(-214.009 -144.984)",
    fill: "#263238",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19633",
    "data-name": "Path 19633",
    d: "M215.34,175.033l.474.161.435-.4a3.267,3.267,0,0,1,.74-.526l.226-.117.122.152a.492.492,0,0,1,.026.6l-.257.37-.87,1.979-.87-.239-.709-.918Z",
    transform: "translate(-214.416 -149.578)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19634",
    "data-name": "Path 19634",
    d: "M135.475,169.428c.5.87,1.053,1.8,1.544,2.719s.992,1.862,1.444,2.8.87,1.888,1.266,2.836a23.654,23.654,0,0,1,.957,2.836l.157.6a1.374,1.374,0,0,1,.03.357,4.032,4.032,0,0,1-.2,1.088,13.074,13.074,0,0,1-1.192,2.588c-.5.87-1.083,1.74-1.692,2.61s-1.266,1.74-1.905,2.549l1.627,1.731A28.03,28.03,0,0,0,142.5,187.3a14.868,14.868,0,0,0,1.971-3.189,8.113,8.113,0,0,0,.618-2.1,5.711,5.711,0,0,0,.03-1.305l-.039-.339-.039-.226-.083-.457c-.1-.622-.252-1.2-.392-1.788a16.1,16.1,0,0,0-.522-1.7c-.365-1.122-.8-2.175-1.266-3.258s-.97-2.084-1.514-3.093q-.4-.757-.835-1.5c-.287-.509-.574-.975-.918-1.5Z",
    transform: "translate(-107.658 -145.448)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19635",
    "data-name": "Path 19635",
    d: "M187.168,141.1c.083.239.026.483-.131.544s-.348-.087-.435-.326-.026-.483.131-.544S187.086,140.864,187.168,141.1Z",
    transform: "translate(-171.949 -130.713)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19636",
    "data-name": "Path 19636",
    d: "M185.205,142.63a9.529,9.529,0,0,1-.435,2.5,1.436,1.436,0,0,0,1.205-.226Z",
    transform: "translate(-169.938 -131.77)",
    fill: "#ed893e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19637",
    "data-name": "Path 19637",
    d: "M185.713,137.522a.148.148,0,0,0,.078-.039,1.183,1.183,0,0,1,1.053-.2.149.149,0,1,0,.078-.287,1.479,1.479,0,0,0-1.331.265.152.152,0,0,0,0,.213A.165.165,0,0,0,185.713,137.522Z",
    transform: "translate(-171.333 -128.554)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19638",
    "data-name": "Path 19638",
    d: "M172.041,143.2c-.083,2.61-1.044,5.729.509,7.269,0,0-.722,2.336-5,2.336-4.711,0-2.175-2.336-2.175-2.336,2.61-.613,2.61-2.523,2.223-4.316Z",
    transform: "translate(-147.777 -132.092)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19639",
    "data-name": "Path 19639",
    d: "M169.476,158.276c.365-.74.744-1.879,0-2.145a16.859,16.859,0,0,0-8.309,0,2.819,2.819,0,0,1,.044,2.306Z",
    transform: "translate(-143.599 -139.098)",
    fill: "#e27345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19640",
    "data-name": "Path 19640",
    d: "M153.337,408.236a3.973,3.973,0,0,0,.822-.087.074.074,0,0,0,.057-.061.065.065,0,0,0-.03-.074c-.035-.026-.87-.613-1.34-.518a.365.365,0,0,0-.244.174.3.3,0,0,0,0,.357A.988.988,0,0,0,153.337,408.236Zm.618-.2c-.474.083-1.118.078-1.249-.1,0,0-.052-.07.022-.191a.213.213,0,0,1,.152-.1A2,2,0,0,1,153.955,408.036Z",
    transform: "translate(-124.163 -281.405)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19641",
    "data-name": "Path 19641",
    d: "M153.424,407.16h.039a.078.078,0,0,0,.039-.07c0-.039-.044-.944-.4-1.249a.409.409,0,0,0-.318-.1.244.244,0,0,0-.244.2c-.07.352.531,1.04.844,1.214Zm-.583-1.279a.235.235,0,0,1,.165.07,1.74,1.74,0,0,1,.335.988c-.309-.244-.692-.761-.653-.97,0,0,0-.07.117-.083Z",
    transform: "translate(-123.445 -280.42)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19642",
    "data-name": "Path 19642",
    d: "M191.256,408.225a5.7,5.7,0,0,0,.97-.087.074.074,0,0,0,.057-.061.078.078,0,0,0-.035-.078c-.157-.091-1.557-.892-1.9-.339a.283.283,0,0,0,0,.331C190.464,408.168,190.851,408.225,191.256,408.225Zm.731-.2c-.592.083-1.392.074-1.527-.122,0,0-.044-.061.022-.165.191-.313,1.04.044,1.5.287Z",
    transform: "translate(-178.651 -281.394)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19643",
    "data-name": "Path 19643",
    d: "M191.359,407.164a.073.073,0,0,0,.044,0,.065.065,0,0,0,.03-.065,2.088,2.088,0,0,0-.435-1.214.522.522,0,0,0-.413-.131c-.209.022-.27.126-.283.213-.061.365.653,1.031,1.031,1.205Zm-.718-1.279a.387.387,0,0,1,.257.1,1.705,1.705,0,0,1,.374.975c-.378-.231-.87-.761-.831-.979,0-.022,0-.078.157-.091Z",
    transform: "translate(-177.802 -280.425)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19644",
    "data-name": "Path 19644",
    d: "M185.684,399.36H182.53l-.03-7.3h3.154Z",
    transform: "translate(-168.66 -272.69)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19645",
    "data-name": "Path 19645",
    d: "M148.865,399.36h-3.154l-1.3-7.3h3.15Z",
    transform: "translate(-115.27 -272.69)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19646",
    "data-name": "Path 19646",
    d: "M147.23,408h3.541a.27.27,0,0,1,.261.217l.513,2.8a.483.483,0,0,1-.483.557c-1.235,0-1.836-.091-3.393-.091-.957,0-2.932.1-4.259.1s-1.444-1.305-.9-1.427a8.151,8.151,0,0,0,4.194-1.962A.8.8,0,0,1,147.23,408Z",
    transform: "translate(-116.998 -281.696)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19647",
    "data-name": "Path 19647",
    d: "M187.707,408h3.445a.261.261,0,0,1,.257.217l.5,2.8a.474.474,0,0,1-.474.557c-1.244,0-3.045-.091-4.594-.091-1.827,0-3.406.1-5.547.1-1.305,0-1.6-1.305-1.057-1.427,2.488-.539,4.5-.6,6.686-1.91A1.491,1.491,0,0,1,187.707,408Z",
    transform: "translate(-173.802 -281.696)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19648",
    "data-name": "Path 19648",
    d: "M141.329,161.422c2.928.679,6,8.735,6,8.735l-6.09,4.063a47.529,47.529,0,0,1-3.663-6.66C135.974,163.871,138.332,160.752,141.329,161.422Z",
    transform: "translate(-110.541 -142.335)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19649",
    "data-name": "Path 19649",
    d: "M141.329,161.422c2.928.679,6,8.735,6,8.735l-6.09,4.063a47.529,47.529,0,0,1-3.663-6.66C135.974,163.871,138.332,160.752,141.329,161.422Z",
    transform: "translate(-110.541 -142.335)",
    fill: "#f6d64f",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19650",
    "data-name": "Path 19650",
    d: "M150.539,173.35l2.519,7.47-.287.191s-1.148-1.7-2.371-4Z",
    transform: "translate(-122.069 -149.126)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19651",
    "data-name": "Path 19651",
    d: "M150.872,174.564c.022,3.519.235,7.9.757,13.325h16.862c.217-2.584-.922-15.226,2.04-27.407a43.5,43.5,0,0,0-5.612-.713,63.458,63.458,0,0,0-7.165,0,32.839,32.839,0,0,0-4.885.87s-1.44,1.566-1.879,8.888C150.9,170.975,150.859,172.641,150.872,174.564Z",
    transform: "translate(-139.747 -141.395)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19652",
    "data-name": "Path 19652",
    d: "M150.872,174.564c.022,3.519.235,7.9.757,13.325h16.862c.217-2.584-.922-15.226,2.04-27.407a43.5,43.5,0,0,0-5.612-.713,63.458,63.458,0,0,0-7.165,0,32.839,32.839,0,0,0-4.885.87s-1.44,1.566-1.879,8.888C150.9,170.975,150.859,172.641,150.872,174.564Z",
    transform: "translate(-139.747 -141.395)",
    fill: "#f6d64f",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19653",
    "data-name": "Path 19653",
    d: "M187.809,184.4c2.541,1.5,4.507-3.641,3.145-7.322l-3.045,2.288C187.836,180.813,187.8,182.479,187.809,184.4Z",
    transform: "translate(-176.684 -151.233)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19654",
    "data-name": "Path 19654",
    d: "M194.633,164.157c.783,2.9-4.664,11.206-4.664,11.206l-6.147-3.428a35.067,35.067,0,0,1,3.867-7.439C190.309,160.9,193.763,160.89,194.633,164.157Z",
    transform: "translate(-178.262 -142.573)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19655",
    "data-name": "Path 19655",
    d: "M194.633,164.157c.783,2.9-4.664,11.206-4.664,11.206l-6.147-3.428a35.067,35.067,0,0,1,3.867-7.439C190.309,160.9,193.763,160.89,194.633,164.157Z",
    transform: "translate(-178.262 -142.573)",
    fill: "#f6d64f",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19656",
    "data-name": "Path 19656",
    d: "M182.53,392.07l.017,3.759H185.7l-.017-3.759Z",
    transform: "translate(-168.69 -272.696)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19657",
    "data-name": "Path 19657",
    d: "M149.01,392.07h-3.15l.67,3.759h3.154Z",
    transform: "translate(-116.72 -272.696)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19658",
    "data-name": "Path 19658",
    d: "M174.865,129.281c.844,3.019,1.492,4.742.548,6.83a4.068,4.068,0,0,1-7.2.513c-1.544-2.406-2.667-6.961-.226-9.231a4.111,4.111,0,0,1,6.873,1.888Z",
    transform: "translate(-151.924 -122.488)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19659",
    "data-name": "Path 19659",
    d: "M170.9,123.492c1.475-.378,2.806.583,2.684,4.233a9.975,9.975,0,0,1-1.653,5.751c-.5.966-.557.113-2.554.748-1.37.435-2.784-4.007-4.585-4.033-2-.03-.292-3.389-.292-3.389-.435.718-4.738,1.205-2.223-2.023C164.5,121.922,172.408,121.4,170.9,123.492Z",
    transform: "translate(-147.427 -120.237)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19660",
    "data-name": "Path 19660",
    d: "M172.293,125.016s-9.906-1.018-12.011-2.34a6.256,6.256,0,0,1,2.023-4.624c.518-.374,4.955-.522,5.99-.231s3.872,1.788,4.2,2.406S172.293,125.016,172.293,125.016Z",
    transform: "translate(-145.916 -117.666)",
    fill: "#e27345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19661",
    "data-name": "Path 19661",
    d: "M153.077,130.94c1.083.809,5.481,4.35,11.154,3.611s-1.47-2.271-1.47-2.271Z",
    transform: "translate(-136.597 -125.165)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19662",
    "data-name": "Path 19662",
    d: "M153.077,130.94c1.083.809,5.481,4.35,11.154,3.611s-1.47-2.271-1.47-2.271Z",
    transform: "translate(-136.597 -125.165)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19663",
    "data-name": "Path 19663",
    d: "M179.431,137.322a3.7,3.7,0,0,1-.479,2.262c-.531.9-1.305.583-1.6-.3-.257-.8-.291-2.223.435-2.819S179.318,136.387,179.431,137.322Z",
    transform: "translate(-160.119 -128.141)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19664",
    "data-name": "Path 19664",
    d: "M143.15,224.517s2.649,24.088,4.263,33.115c1.766,9.88,6.243,42.781,6.243,42.781h5.773s-1.74-32.118-2.61-41.9c-.922-10.619-2.806-34.011-2.806-34.011Z",
    transform: "translate(-125.286 -178.024)",
    fill: "#abacaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19665",
    "data-name": "Path 19665",
    d: "M142.251,394.15c-.026,0,.509,2.219.509,2.219h6.5l-.039-1.979Z",
    transform: "translate(-114.72 -273.871)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19666",
    "data-name": "Path 19666",
    d: "M170.16,244.226c4.1.809,3.071,16.235,2.267,24.17-.979-5.608-2.306-16.4-3.2-24.057A1.41,1.41,0,0,1,170.16,244.226Z",
    transform: "translate(-150.364 -189.149)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19667",
    "data-name": "Path 19667",
    d: "M170.211,224.54s-1.344,23.566-1.37,33.18c-.03,10.006,2.2,42.733,2.2,42.733h5.342s1.436-32.153,2.053-41.972c.67-10.7,2.863-33.932,2.863-33.932Z",
    transform: "translate(-158.328 -178.046)",
    fill: "#abacaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19668",
    "data-name": "Path 19668",
    d: "M178.582,394.15c-.026,0,.218,2.219.218,2.219h6.5l.252-1.979Z",
    transform: "translate(-166.817 -273.871)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Post--inject-20",
    transform: "translate(0 0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19669",
    "data-name": "Path 19669",
    d: "M240.589,166.16l-11.219,4.751V166.16Z",
    transform: "translate(-167.526 -145.914)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5697",
    "data-name": "Rectangle 5697",
    width: 60.295,
    height: 85.118,
    rx: 3,
    transform: "translate(0 0)",
    fill: "#4895cf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5698",
    "data-name": "Rectangle 5698",
    width: 60.295,
    height: 85.118,
    rx: 3,
    transform: "translate(1.549 0)",
    fill: "#55a9dd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5699",
    "data-name": "Rectangle 5699",
    width: 60.295,
    height: 50.242,
    transform: "translate(1.549 24.997)",
    fill: "#fafafa",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19670",
    "data-name": "Path 19670",
    d: "M271.987,137.053a2.567,2.567,0,1,0-2.567-2.567A2.567,2.567,0,0,0,271.987,137.053Zm0-4.677a2.1,2.1,0,1,0,0,.013Z",
    transform: "translate(-218.913 -126.569)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19671",
    "data-name": "Path 19671",
    d: "M289.192,137.053a2.567,2.567,0,1,0-2.562-2.567A2.567,2.567,0,0,0,289.192,137.053Zm0-4.677a2.1,2.1,0,1,0,0,.013Z",
    transform: "translate(-243.61 -126.569)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19672",
    "data-name": "Path 19672",
    d: "M306.417,137.053a2.567,2.567,0,1,0-2.567-2.567A2.567,2.567,0,0,0,306.417,137.053Zm0-4.677a2.1,2.1,0,1,0,0,.013Z",
    transform: "translate(-268.321 -126.569)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19673",
    "data-name": "Path 19673",
    d: "M312.47,302.06a1.236,1.236,0,1,0,.362-.878A1.24,1.24,0,0,0,312.47,302.06Z",
    transform: "translate(-278.037 -221.992)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19674",
    "data-name": "Path 19674",
    d: "M321.61,302.06a1.236,1.236,0,1,0,.362-.878A1.24,1.24,0,0,0,321.61,302.06Z",
    transform: "translate(-291.153 -221.992)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19675",
    "data-name": "Path 19675",
    d: "M330.75,302.06a1.24,1.24,0,1,0,1.24-1.24A1.24,1.24,0,0,0,330.75,302.06Z",
    transform: "translate(-304.269 -221.992)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5700",
    "data-name": "Rectangle 5700",
    width: 16.84,
    height: 16.84,
    rx: 4.16,
    transform: "translate(41.28 28.721)",
    fill: "#316bb1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_588",
    "data-name": "Ellipse 588",
    cx: 3.324,
    cy: 3.324,
    r: 3.324,
    transform: "translate(46.374 31.392)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19676",
    "data-name": "Path 19676",
    d: "M275.758,210.27c2.61,0,4.816,1.2,5.555,2.845a.87.87,0,0,1-.787,1.209h-9.519a.87.87,0,0,1-.787-1.209C270.947,211.458,273.153,210.27,275.758,210.27Z",
    transform: "translate(-226.06 -170.834)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19677",
    "data-name": "Path 19677",
    d: "M267.392,269.893h45.5a3.672,3.672,0,0,0,3.672-3.672h0a3.672,3.672,0,0,0-3.672-3.672h-45.5a3.672,3.672,0,0,0-3.672,3.676h0A3.672,3.672,0,0,0,267.392,269.893Z",
    transform: "translate(-258.447 -200.371)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19678",
    "data-name": "Path 19678",
    d: "M267.392,245.113h45.5a3.672,3.672,0,0,0,3.672-3.672h0a3.672,3.672,0,0,0-3.672-3.672h-45.5a3.672,3.672,0,0,0-3.672,3.672h0A3.672,3.672,0,0,0,267.392,245.113Z",
    transform: "translate(-258.447 -186.371)",
    fill: "#333",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5701",
    "data-name": "Rectangle 5701",
    width: 31.723,
    height: 2.232,
    transform: "translate(5.381 31.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5702",
    "data-name": "Rectangle 5702",
    width: 31.723,
    height: 2.232,
    transform: "translate(5.381 36.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5703",
    "data-name": "Rectangle 5703",
    width: 25.362,
    height: 2.232,
    transform: "translate(11.746 40.206)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteKycIcon);
export default __webpack_public_path__ + "static/media/complete-kyc-icon.8cae183ea470bace3105a13bb1406046.svg";
export { ForwardRef as ReactComponent };